import { Link, useNavigate } from "react-router";
import { Container } from "@/shared/components/layout/Container";
import { Section } from "@/shared/components/layout/Section";
import { useCreateHousehold } from "@/shared/lib/households";
import { HouseholdForm } from "./HouseholdForm";

export function HouseholdNew() {
  const navigate = useNavigate();
  const create = useCreateHousehold();

  return (
    <Section spacing="md">
      <Container size="4xl">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-2">
            <Link
              to="/app/contacts/households"
              className="type-label-sm tracking-wider uppercase text-text-muted hover:text-text"
            >
              ← Back to households
            </Link>
            <h1 className="type-heading-lg text-text">New household</h1>
          </div>
          <HouseholdForm
            mode="create"
            submitLabel="Create household"
            pending={create.isPending}
            error={create.error}
            onSubmit={(input) =>
              create.mutate(input, {
                onSuccess: (hh) => navigate(`/app/contacts/households/${hh.id}`),
              })
            }
          />
        </div>
      </Container>
    </Section>
  );
}
